import styled from "styled-components";
import { Table } from "semantic-ui-react";

export const Content = styled.div`
  width: 100%;
  margin-top: 1rem;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  min-height: 85vh;
  padding: 1rem;

  background: #ffffff;
`;

export const Image = styled.img`
  max-width: 800px;
  max-height: 200px;
`;

export const Field = styled.div`
  width: 100%;
  margin-top: 15px;
  display: block;
`;
export const Modall = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  -webkit-transition: all 0.5s 0.5s ease-in-out;
  transition: all 0.5s 0.5s ease-in-out;
`;
export const CheckUI = styled.div`
  width: 100%;
  position: relative;
  display: inline-block;
  backface-visibility: hidden;
  outline: 0;
  vertical-align: baseline;
  font-style: normal;
  min-height: 17px;
  font-size: 1rem;
  line-height: 17px;
  min-width: 17px;
`;
export const Veja = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.28571429rem;
  padding: 10px;
`;

export const Tambem = styled.div`
  position: relative;
  display: inline-block;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  outline: 1;
  vertical-align: baseline;
  font-style: normal;
  min-height: 17px;
  font-size: 1rem;
  line-height: 17px;
  min-width: 17px;
  clear: both;
  margin: 0 0 1em;
  box-sizing: inherit;
  font-size: 1rem;
  margin: 0;
`;

export const InlineField = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div + div {
    margin-left: 10px;
  }

  margin: ${props => props.margin || "initial"};

  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
`;
export const Dropzone = styled.img`
  height: 5rem;
  width: 100px;
`;

export const CheckBoxField = styled(Field)`
  display: flex;
  align-items: center;

  div {
    margin-left: 15px !important;

    label {
      padding-left: 20px !important;
    }
  }
`;

export const Title = styled.h1`
  width: 100%;

  margin: 15px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const Label = styled.label`
  color: ${props => `${props.color}`};

  font-size: 12px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const InputFile = styled(Input)`
  height: 45px;
`;

export const Select = styled.select`
  width: 100%;
  height: 35px;
  /* margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease; */
`;

export const Textarea = styled.textarea`
  width: 100%;
  height: 110px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const InputFileEdit = styled.input`
  width: 11% !important;
  height: 30px;
  padding: 0px !important;
  border: 0 !important;
  display: block;

  margin-top: 10px !important;

  &::-webkit-file-upload-button {
    visibility: hidden;
  }

  &::before {
    content: "Escolha arquivo";
    display: inline-block;
    background: linear-gradient(top, #f9f9f9, #e3e3e3);
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
  }

  &:hover::before {
    border-color: black;
  }

  &:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  }
`;

export const Button = styled.button`
  width: ${props => props.width || "130px"};
  height: 35px;

  margin-top: 10px;

  background: rgba(0, 0, 0, 0.87) !important;
  color: #ffffff;

  font-size: 14px;
  font-weight: 600;

  border: 0px;
  border-radius: 5px;

  display: block;

  cursor: pointer;
  transition: all 0.5s;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }

  tfoot {
    a {
      color: #000000 !important;

      i {
        color: #000000 !important;
      }
    }
  }

  .status {
    text-align: center;
    color: #fff;
    border-radius: 5px;
  }
  .active {
    background-color: green;
  }
  .canceled {
    background-color: red;
  }
`;

export const Link = styled.a`
  margin-top: ${({ margin }) => margin || "0px"};
  ${({ color }) => !!color && `background-color: ${color};`}
  padding: 7px;
  border-radius: 4px;
  color: ${({ color }) => (!color ? "#000" : "#fff")};
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100px;
  ${({ color }) => !color && ` border: 1px solid #000;`}

  svg {
    margin-right: 5px;
  }

  &:hover {
    background-color: var(--color-primary);
    color: #fff;
    border-color: var(--color-primary);
  }
`;
